import React from 'react';
import { Alert } from 'react-bootstrap';
import styled from 'styled-components';





/**
 * @function
 * @description
 * A React component that indicates that an event has already happened.
 * @returns {ReactElement} A React element representing the component.
 */
export default function EventHappenedInPast() {
  return (
    <PastEventWrapper>
      <Alert variant="warning">
        <h4>This event has already happened.</h4>
        <p>Thank you for your interest. Please check our upcoming events for more opportunities.</p>
      </Alert>
    </PastEventWrapper>
  );
}

const PastEventWrapper = styled.div`
  margin-top: 60px;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 1rem;
  @media (min-width: 1024px) {
    min-width: 100%;
    max-width: 100%;
  }
`;